// extracted by mini-css-extract-plugin
module.exports = {"view-slider-item-wrapper-info":"styles__view-slider-item-wrapper-info__1GGW9","viewSliderItemWrapperInfo":"styles__view-slider-item-wrapper-info__1GGW9"};